import { Button } from "@/pages/newHome/ui/button";
import mobile1 from "@/assets/newHome/mobile-1.png";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const AppByAnima = (): JSX.Element => {
    const navigate = useNavigate();
    // const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
    const user = useSelector(
      (state: RootState) => state.rootReducer.userReducer.user
    );
  
  return (
    <section className="w-full bg-gradient-to-b from-white to-[#eefff2] px-4 md:px-8 pt-10 pointer-events-auto">
      <div className="max-w-7xl mx-auto items-end flex flex-col md:flex-row justify-between gap-6 sm:gap-10 lg:gap-10 xl:gap-10 2xl:gap-10 md:gap-[116px] h-full">
        
        {/* Text Section */}
        <div className="flex flex-col justify-between w-full md:w-1/2 gap-6 pb-10">
          <div className="flex flex-col gap-6">
            <div className="text-primary text-xl font-medium leading-7 text-left">
              Powered By
            </div>

            <h2 className="text-3xl md:text-[40px] font-semibold mt-[-14px] sm:mt-0 text-charcoal leading-tight lg:leading-[56px] text-left">
              AI + Data + CRM + Automation
            </h2>

            <p className="text-charcoal text-lg md:text-[22px] leading-[1.6] lg:leading-[35.2px] text-left">
              Unlock the full potential of your sales with AI-powered insights – 
              combined with powerful real-time data and CRM tools.
            </p>
          </div>

          {/* Button with margin from bottom */}
          <div className="mt-0 sm:mt-2 md:mt-2 lg:mt-2 xl:mt-2 2xl:mt-2 flex">
            {/* <ScheduleDemo>
            <Button className="justify-start px-6 py-[15px] h-[50px] rounded-[40px] bg-primary hover:bg-[#229a3f] text-white text-md md:text-xl font-medium">
              Get Started
            </Button>
            </ScheduleDemo> */}
            
              <Button
              onClick={(e) => {
                if (user) {
                  e.preventDefault();
                  navigate("/dashboard/explore_leads");
                } else {
                  // window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank");
                  //  window.open(`${window.location.origin}/newOnboarding`, "_self");
                  navigate("auth/signup")
                }
              }}
              className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white"
            >
              Get Started
            </Button>
          </div>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-end md:items-end">
          <img
            src={mobile1}
            alt="Mobile App"
            className="w-full max-w-[482px] h-auto object-contain self-end"
          />
        </div>
      </div>
    </section>
  );
};